<template>
  <b-card no-body>
    <b-card-body>
      <customer-document-detail
        ref="customerParameterDetail"
        type="edit"
        :submitting="submitting"
        :values="data"
        @submit="submit"
      />
    </b-card-body>
  </b-card>
</template>

<script>
import { useUtils as useI18nUtils } from '@core/libs/i18n';
import { BCard, BCardBody } from 'bootstrap-vue';
import { helper } from '@core/mixins/helper';
import useService from '@/auth/service/useService';
import CustomerDocumentDetail from '@/views/pages/customers/CustomerDocumentDetail.vue';

export default {
  components: {
    BCard,
    BCardBody,
    CustomerDocumentDetail
  },
  mixins: [helper],
  data() {
    return {
      submitting: false,
      data: {}
    };
  },

  created() {
    const documentId = this.$route.params.document_id;
    this.id = documentId;
    this.getParameterData(this.id);
  },
  methods: {
    submit(data) {
      this.submitting = true;

      const request = {
        document_type: data.documentType,
        status: data.status
      };

      const id = this.$route.params.document_id;

      useService
        .editCustomerDocument(id, request)
        .then(response => {
          // this.$refs.customerUserDetail.resetForm()
          this.showSuccessMessage(`${response.message}`);
          this.$router.push({
            name: 'customers_documents_list',
            params: { id: this.$route.params.id }
          });
        })
        .catch(messages => {
          if (typeof messages === 'object' && messages && messages.length) {
            messages.forEach(item => {
              this.showErrorMessage(item.message);
            });
          }
        })
        .finally(() => {
          this.submitting = false;
        });
    },

    getParameterData(id) {
      this.submitting = true;
      useService
        .getDocument(id)
        .then(response => {
          this.data = response.data;

          const { documentType, status } = response.data;

          this.data = {
            documentType,
            status
          };
        })
        .catch(messages => {
          if (typeof messages === 'object' && messages && messages.length) {
            messages.forEach(item => {
              this.showErrorMessage(item.message);
            });
          }
        })
        .finally(() => {
          this.submitting = false;
        });
    }
  },
  setup() {
    const { t } = useI18nUtils();

    return {
      t
    };
  }
};
</script>
